module.exports = __webpack_public_path__ + "static/media/override@2x.d3100a98.svg";